import type { MarketNewsItem } from '@/types';
import type { HomeMetric } from './types';

interface ResearchHomeStatsNewsProps {
  metrics: HomeMetric[];
  listsLoading: boolean;
  news: MarketNewsItem[];
  newsLoading: boolean;
  newsError: boolean;
}

export default function ResearchHomeStatsNews({
  metrics,
  listsLoading,
  news,
  newsLoading,
  newsError,
}: ResearchHomeStatsNewsProps) {
  return (
    <div className="rh-bottom">
      <div className="rh-metrics">
        {metrics.map((m) => (
          <div key={m.label} className="rh-metric-card">
            <div className="rh-metric-label">{m.label}</div>
            <div className="rh-metric-value">
              {listsLoading ? <span className="rh-skeleton rh-skeleton--num" /> : m.display}
            </div>
          </div>
        ))}
      </div>

      <section className="rh-panel rh-news-panel" aria-labelledby="rh-news-heading">
        <div className="rh-panel-head">
          <div className="rh-panel-title">
            <i className="bi bi-newspaper" aria-hidden="true" />
            <h2 id="rh-news-heading">Private Market News</h2>
          </div>
        </div>
        <div className="rh-panel-body rh-panel-body--news">
          {newsLoading ? (
            <div className="rh-skel-stack">
              {[0, 1, 2].map((i) => (
                <span key={i} className="rh-skeleton rh-skeleton--row" />
              ))}
            </div>
          ) : newsError ? (
            <p className="rh-empty">Couldn&apos;t load news right now. Try again shortly.</p>
          ) : news.length === 0 ? (
            <p className="rh-empty">No recent headlines available.</p>
          ) : (
            <ul className="rh-news">
              {news.slice(0, 3).map((n, i) => (
                <li key={`${n.url}-${i}`}>
                  <a
                    href={n.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rh-news-item"
                  >
                    <p className="rh-news-title">{n.title}</p>
                    <p className="rh-news-meta">
                      {n.source && <span className="rh-news-source">{n.source}</span>}
                      {n.source && n.age && <span className="rh-news-dot">·</span>}
                      {n.age && <span>{n.age}</span>}
                    </p>
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </div>
  );
}
